import { ChangeDetectionStrategy, Component, computed, inject, ViewEncapsulation } from "@angular/core";
import { S25ButtonComponent } from "../../standalone/s25.button.component";
import { S25IconComponent } from "../s25-icon/s25.icon.component";
import { AcademicGridStore } from "./s25.academic.grid.store";
import { AcademicGrid } from "./s25.academic.grid";
import { S25AcademicGridComponent } from "./s25.academic.grid.component";
import { S25Util } from "../../util/s25-util";

@Component({
    standalone: true,
    selector: "s25-ng-academic-grid-active-filters",
    template: `
        @for (type of filterTypes(); track type) {
            @for (filter of store.filters()[type].filters; track filter.label) {
                @let test = filter.active() && (filter.showText?.() ?? true) && filter.type !== "none";
                @if (test) {
                    <div class="activeFilter" [attr.data-filter-type]="type">
                        <s25-ng-button [type]="'none'" (clicked)="clearFilter(filter)" [ariaLabel]="'Remove filter'">
                            <s25-ng-icon [type]="'close'" [ariaLabel]="false" />
                        </s25-ng-button>
                        <span>{{ filter.label }}: </span>
                        <span [title]="filter.text()">{{ filter.text() }}</span>
                    </div>
                }
            }
        }
    `,
    styles: `
        :host {
            display: flex;
            justify-content: right;
            gap: 0.5rem;
            flex-wrap: wrap-reverse;
            padding-bottom: 0.5rem;
        }

        .activeFilter {
            font-size: 0.8em;
            border-radius: 1em;
            padding: 0.1rem 0.4rem 0 0.2rem;
            background: var(--filter-background, var(--cn-blue));
            margin-bottom: -0.05em;
            max-width: 20em;
            text-overflow: ellipsis;
            text-wrap: nowrap;
            overflow: hidden;
            color: white;
            height: fit-content;
        }

        .activeFilter s25-ng-button {
            float: left;
            padding-top: 0.1em;
        }

        [data-filter-type="items"] {
            --filter-background: var(--color--objects-event);
        }
    `,
    encapsulation: ViewEncapsulation.Emulated,
    imports: [S25ButtonComponent, S25IconComponent],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class S25AcademicGridActiveFiltersComponent {
    readonly store = inject(AcademicGridStore);
    readonly academicGrid = inject(S25AcademicGridComponent);

    readonly filterTypes = computed(() => S25Util.objectKeys(this.store.filters()));

    clearFilter(filter: AcademicGrid.Filter): void {
        filter.clear();
        this.academicGrid.applyFilters();
    }
}
